import React from 'react';
import { DismissBookingModal } from '../../ScheduledBookings';
import { NO_SCHEDULED_HOURS } from './scheduledHours';
import type { Project, TimesheetEntry } from '@/types/timesheet';

export interface DismissBookingDialogProps {
  selectedBookingForDismiss: TimesheetEntry | null;
  setSelectedBookingForDismiss: React.Dispatch<React.SetStateAction<TimesheetEntry | null>>;
  handleDismissBooking: (index: number, reason: string, customReason?: string) => void;
  allAvailableProjects: Project[];
  entries: TimesheetEntry[];
}

/** Captures the reason for dismissing a scheduled booking row. */
export function DismissBookingDialog({
  selectedBookingForDismiss,
  setSelectedBookingForDismiss,
  handleDismissBooking,
  allAvailableProjects,
  entries,
}: DismissBookingDialogProps) {
  if (!selectedBookingForDismiss) return null;

  return (
    <DismissBookingModal
      open={!!selectedBookingForDismiss}
      onOpenChange={(open) => !open && setSelectedBookingForDismiss(null)}
      booking={{
        projectName: allAvailableProjects.find(p => p.id === selectedBookingForDismiss.projectId)?.name || 'Unknown Project',
        scheduledHours: selectedBookingForDismiss.scheduledHours || NO_SCHEDULED_HOURS,
      }}
      onConfirm={(reason, customReason) => {
        const index = entries.findIndex(e => e.id === selectedBookingForDismiss.id);
        if (index !== -1) {
          handleDismissBooking(index, reason, customReason);
        }
        setSelectedBookingForDismiss(null);
      }}
    />
  );
}
